import React, { ChangeEvent, useCallback } from 'react';

import { eventPreventDefault } from '@lyearn/core/utils/events';
import { useTranslation } from '@lyearn/i18n';
import { AddBlock } from '@lyearn/molecules';
import { Box, FileInput, useSnackbar } from '@lyearn/ui';

import { allowedFileExtension } from '../../consts';
import { buttonInput } from './style';
import { AddSubtitleProps } from './types';

const MB = 1024 * 1024;
const MAX_FILE_SIZE = 10 * MB;

const AddSubtitle: React.FC<AddSubtitleProps> = (props) => {
  const { setFile, file, loadingCaption } = props;
  const { t } = useTranslation();
  const { showErrorSnackbar } = useSnackbar();

  const handleInputChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const addedFile = event.target.files?.[0];
      if (!addedFile) {
        return;
      }

      const addedFileExtension = addedFile.name.split('.').pop();
      if (!allowedFileExtension.includes(addedFileExtension!)) {
        showErrorSnackbar({ message: t('Lygo:AdvancedMenu.video.Subtitles.fileTypeError') });
      } else if (addedFile.size > MAX_FILE_SIZE) {
        showErrorSnackbar({ message: t('Lygo:AdvancedMenu.video.Subtitles.fileSizeError') });
      } else {
        setFile(addedFile);
      }
      event.target.value = '';
    },
    [setFile, showErrorSnackbar, t],
  );

  const onFileSelectErrorHandler = useCallback(() => {
    showErrorSnackbar({
      message: t('Common:FileTypeNotAllowedToBeUploaded', { accept: allowedFileExtension }),
    });
  }, [showErrorSnackbar, t]);

  const disableState = !!(file || loadingCaption);

  return (
    <Box className="mt-12">
      <FileInput
        accept={allowedFileExtension}
        className={buttonInput}
        disabled={disableState}
        id={'subtitle-input'}
        onChange={handleInputChange}
        onFileSelectError={onFileSelectErrorHandler}
      />
      <label htmlFor={'subtitle-input'}>
        <AddBlock
          // @ts-ignore
          component="span"
          title={t('Lygo:AdvancedMenu.video.Subtitles.addButton')}
        />
      </label>
    </Box>
  );
};

export default AddSubtitle;
